var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-slide"},[_c('a',{attrs:{"href":_vm.link}},[_c('h2',{attrs:{"data-logo":_vm.isLargeTitleLogo}},[_vm._v(_vm._s(_vm.largeTitle))]),_c('p',[_c('small',[_vm._v(_vm._s(_vm.smallTitle))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }